import React, { useEffect, useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../services/api';

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('academy_token') || ''}` });
const STATUS_CLS = { paid: 'text-emerald-400', pending: 'text-amber-400', expired: 'text-zinc-500' };

export default function PreRegisterAdmin() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/preregister/admin/list', { headers: authHeaders() })
      .then((r) => setRows(r.data.registrations))
      .catch(() => setErr('Admin login required. Log in at /academy/login as an admin, then reload.'));
  }, []);

  const download = async () => {
    try {
      const r = await api.get('/preregister/admin/export.csv', { headers: authHeaders(), responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = 'preregistrations-2027-28.csv'; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error('Download failed'); }
  };

  const paid = (rows || []).filter((r) => r.payment_status === 'paid');
  return (
    <div className="min-h-screen bg-black text-white px-4 py-8" data-testid="preregister-admin-page">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
          <div>
            <div className="text-[10px] font-black tracking-[0.3em] uppercase text-[#C9A961]">2027–28</div>
            <h1 className="text-3xl font-black uppercase">Pre-Registrations</h1>
            {rows && <div className="text-xs text-zinc-400 mt-1" data-testid="prereg-admin-counts">{paid.length} paid · ${(paid.length * 650).toLocaleString()} collected · {rows.length - paid.length} unpaid/abandoned</div>}
          </div>
          <button onClick={download} className="flex items-center gap-2 bg-[#FF5E00] text-black px-4 py-2.5 text-[10px] font-black uppercase tracking-widest" data-testid="prereg-admin-csv"><Download className="w-4 h-4" /> CSV</button>
        </div>
        {err ? <div className="text-sm text-red-400" data-testid="prereg-admin-error">{err}</div> : !rows ? <Loader2 className="w-6 h-6 animate-spin text-[#FF5E00]" /> : (
          <div className="overflow-x-auto border-2 border-zinc-800">
            <table className="w-full text-xs" data-testid="prereg-admin-table">
              <thead className="bg-zinc-950 text-zinc-500 uppercase tracking-widest text-[9px]">
                <tr>{['Status', 'Date', 'Parent', 'Student', 'Grade', 'Current School', 'Reclass', 'Sport', 'Email', 'Phone'].map((h) => <th key={h} className="text-left px-3 py-2.5 font-black">{h}</th>)}</tr>
              </thead>
              <tbody>
                {rows.length === 0 && <tr><td colSpan={10} className="px-3 py-8 text-center text-zinc-500">No pre-registrations yet.</td></tr>}
                {rows.map((r) => (
                  <tr key={r.id} className="border-t border-zinc-900" data-testid={`prereg-row-${r.id}`}>
                    <td className={`px-3 py-2.5 font-black uppercase ${STATUS_CLS[r.payment_status] || ''}`}>{r.payment_status}</td>
                    <td className="px-3 py-2.5 text-zinc-400">{(r.paid_at || r.created_at || '').slice(0, 10)}</td>
                    <td className="px-3 py-2.5">{r.parent_name}</td>
                    <td className="px-3 py-2.5 font-bold">{r.student_name}</td>
                    <td className="px-3 py-2.5">{r.grade}</td>
                    <td className="px-3 py-2.5">{r.current_school}</td>
                    <td className="px-3 py-2.5">{r.reclassing ? 'Yes' : 'No'}</td>
                    <td className="px-3 py-2.5">{r.sport}</td>
                    <td className="px-3 py-2.5"><a href={`mailto:${r.email}`} className="underline">{r.email}</a></td>
                    <td className="px-3 py-2.5"><a href={`tel:${r.phone}`} className="underline">{r.phone}</a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
